import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

function Testimonials() {
  const testimonials = [
    {
      name: "Sarah Smith",
      text: "The courses are well-structured and easy to follow.",
      image: "https://randomuser.me/api/portraits/women/2.jpg",
    },
    {
        name: "Sarah Smith",
        text: "The courses are well-structured and easy to follow.",
        image: "https://randomuser.me/api/portraits/women/2.jpg",
      },
      {
        name: "Sarah Smith",
        text: "The courses are well-structured and easy to follow.",
        image: "https://randomuser.me/api/portraits/women/2.jpg",
      },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: false,
  };

  return (
    <>
      <style>
        {`
        .testimonial-container {
        
          text-align: center;
          margin: auto;
          max-width: 600px; /* Default width */
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .testimonial-container {
            max-width: 80%;
          }
        }

        @media (max-width: 576px) {
          .testimonial-container {
            max-width: 90%;
          }
          .testimonial-text {
            width: 100%;
          }
        }

        .testimonial-box {
          padding: 20px;
          box-shadow: 0 4px 8px rgba(0,0,0,0.2);
          transition: transform 0.7s ease-in-out;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 250px; 
        }

        .testimonial-box:hover {
          transform: scale(1.05);
        }

        .testimonial-img {
          width: 80px;
          height: 80px;
          border-radius: 70%;
          margin-bottom: 10px;
          border: 3px solid yellowgreen;
        }

        .testimonial-name {
          font-size: 1.5rem;
          font-weight: bold;
          margin-top: 10px;
          color: yellowgreen;
        }

        .testimonial-text {
          font-style: italic;
          color: #001f3f;
          width: 70%;
          transition: background 0.3s ease-in-out, color 0.3s ease-in-out;
          border-radius: 5px;
          text-align: center;
        }

        .testimonial-text:hover {
          background-color: #001f3f;
          color: white;
        }

        .slick-dots li button:before {
          color: yellowgreen;
          font-size:1.1
        }
      `}
      </style>

      <div className="testimonial-container container px-3 px-md-5">
        <Slider {...settings}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-box">
              <div className="d-flex justify-content-center">
                <img src={testimonial.image} alt={testimonial.name} className="testimonial-img" />
              </div>
              <p className="testimonial-name">{testimonial.name}</p>
              <div className="container d-flex justify-content-center">
                <p className="testimonial-text p-2">"{testimonial.text}"</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
}

export default Testimonials;
